import { Layout } from "@/components/Layout";
import { Hero } from "@/components/Hero";
import { TrustSignals } from "@/components/TrustSignals";
import { Logistics } from "@/components/Logistics";
import { Testimonial } from "@/components/Testimonial";
import { CTA } from "@/components/CTA";
import { SEO } from "@/components/SEO";

const Index = () => {
  const schema = {
    "@context": "https://schema.org",
    "@type": "LogisticsService",
    name: "911 Sourcing",
    description:
      "Specialized logistics for the green and snow industries. De-icing salt supply and wholesale plant sourcing across KY, TN, OH, IN.",
    url: "https://911sourcing.com",
    areaServed: ["KY", "TN", "OH", "IN"],
  };

  return (
    <Layout>
      <SEO
        title="911 Sourcing | Emergency Logistics"
        description="Specialized logistics for the green and snow industries. De-icing salt supply and wholesale plant sourcing across KY, TN, OH, IN."
        url="/"
        schema={schema}
      />
      <Hero />
      <TrustSignals />
      <Logistics />
      <Testimonial />
      <CTA />
    </Layout>
  );
};

export default Index;
